<script lang="ts" setup>
defineProps<{
  title: string
}>()
</script>

<template>
  <div
    class="
      w-min text-nowrap rounded-[60px] bg-[#57A0F7] px-4 py-2 text-xs leading-normal tracking-[-0.01em]
      text-white md:text-base md:font-medium
    "
  >
    {{ title }}
  </div>
</template>
